var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.97899 1.2237C4.19462 1.0512 4.22959 0.736554 4.05708 0.520923C3.88458 0.305292 3.56993 0.270331 3.3543 0.442836L1.68763 1.77617C1.472 1.94867 1.43704 2.26332 1.60955 2.47895C1.78205 2.69458 2.0967 2.72954 2.31233 2.55704L3.97899 1.2237Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6457 0.442836C12.43 0.270331 12.1154 0.305292 11.9429 0.520923C11.7704 0.736554 11.8053 1.0512 12.021 1.2237L13.6876 2.55704C13.9033 2.72954 14.2179 2.69458 14.3904 2.47895C14.5629 2.26332 14.528 1.94867 14.3123 1.77617L12.6457 0.442836Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49998 5.33327C8.49998 5.05713 8.27612 4.83327 7.99998 4.83327C7.72384 4.83327 7.49998 5.05713 7.49998 5.33327L7.49998 7.6666C7.49998 8.49503 8.17155 9.1666 8.99998 9.1666H9.99998C10.2761 9.1666 10.5 8.94275 10.5 8.6666C10.5 8.39046 10.2761 8.1666 9.99998 8.1666H8.99998C8.72384 8.1666 8.49998 7.94275 8.49998 7.6666L8.49998 5.33327Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 0.83327C4.04194 0.83327 0.833313 4.0419 0.833313 7.99994C0.833313 11.958 4.04194 15.1666 7.99998 15.1666C11.958 15.1666 15.1666 11.958 15.1666 7.99994C15.1666 4.0419 11.958 0.83327 7.99998 0.83327ZM1.83331 7.99994C1.83331 4.59418 4.59422 1.83327 7.99998 1.83327C11.4057 1.83327 14.1666 4.59418 14.1666 7.99994C14.1666 11.4057 11.4057 14.1666 7.99998 14.1666C4.59422 14.1666 1.83331 11.4057 1.83331 7.99994Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWatch);
export default __webpack_public_path__ + "static/media/circle-watch.f35cd85df3683542740a3684f82cba91.svg";
export { ForwardRef as ReactComponent };